import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FiCheckCircle, FiXCircle, FiSettings, FiPlus } from 'react-icons/fi';
import api from '../../api';

const RoleTableFunction = () => {
  const [roles, setRoles] = useState([]);
  const [fonctions, setFonctions] = useState([]);

  const colors = {
    primary: '#2C3E50',
    secondary: '#34495E',
    accent: '#875A7B',
    light: '#ECF0F1',
    success: '#27AE60',
    danger: '#E74C3C',
    text: '#2C3E50',
    border: '#BDC3C7',
    accentHover: '#6d4961'
  };

  useEffect(() => {
    api.get('/parametrages/roles')
      .then(response => {
        const allRoles = response.data.roles;

        // Récupérer toutes les fonctions utilisées
        const allFonctions = new Set();
        allRoles.forEach(role => {
          role.functions.forEach(func => {
            allFonctions.add(JSON.stringify({ id: func.id, nom: func.nom }));
          });
        });

        setRoles(allRoles);
        setFonctions([...allFonctions].map(f => JSON.parse(f)));
      })
      .catch(error => {
        console.error('Erreur lors du chargement des rôles:', error);
      });
  }, []);

  return (
    <div className="p-8 min-h-screen" style={{ backgroundColor: colors.light }}>
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold" style={{ color: colors.primary }}>
            <FiSettings className="inline mr-3" size={24} />
            Autorisations par Fonction
          </h1>

          <Link to='/admin/RoleFonctionSelector'>
            <button
              className="flex items-center px-4 py-2 rounded-md shadow-sm transition-colors duration-200"
              style={{
                backgroundColor: colors.accent,
                color: 'white',
                fontWeight: '500'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = colors.accentHover}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = colors.accent}
            >
              <FiPlus className="mr-2" size={18} />
              UPDATE AUTORISATION
            </button>
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden border" style={{ borderColor: colors.border }}>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ backgroundColor: colors.primary, color: 'white' }}>
                  <th className="p-4 text-left font-medium">FONCTION</th>
                  {roles.map(role => (
                    <th key={role.id} className="p-4 text-center font-medium">{role.nom.toUpperCase()}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {fonctions.map(fonction => (
                  <tr key={fonction.id} className="border-t" style={{ borderColor: colors.border }}>
                    <td className="p-4 font-semibold text-left" style={{ color: colors.text }}>
                      {fonction.nom}
                    </td>
                    {roles.map(role => {
                      const hasFunction = role.functions.some(f => f.id === fonction.id);
                      return (
                        <td key={role.id} className="p-4 text-center">
                          {hasFunction ? (
                            <FiCheckCircle size={20} style={{ color: colors.success }} />
                          ) : (
                            <FiXCircle size={20} style={{ color: colors.danger }} />
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-6 text-sm text-right" style={{ color: colors.secondary }}>
          {roles.length} rôles • {fonctions.length} fonctions
        </div>
      </div>
    </div>
  );
};

export default RoleTableFunction;
